<nb-card>
  <nb-card-header>Confirm Annual Leave</nb-card-header>
  <nb-card-body>
    <p class="confirm-text">
      <ng-container
        *ngIf="
          data?.employeeStatus === 'Maternity leave' ||
            data?.employeeStatus === 'Parental leave';
          else defaultText
        "
      >
        This employee is on {{ data?.employeeStatus?.toLowerCase() }}. A payroll
        adjustment of {{ data?.hours }} hours and {{ data?.minutes }} minutes
        will be generated.
      </ng-container>

      <ng-template #defaultText>
        You are requesting for {{ data?.hours }} hours and
        {{ data?.minutes }} minutes of {{ data?.eventType }}.
        {{ data?.days }}
      </ng-template>

      <br />
      Please confirm
    </p>
  </nb-card-body>
  <nb-card-footer>
    <div class="buttons-container">
      <button class="btn btn-success" (click)="close('confirm')">
        Confirm
      </button>
      <button class="btn btn-danger" (click)="close(null)">Cancel</button>
    </div>
  </nb-card-footer>
</nb-card>
